import tw from 'tailwind-styled-components'

export const TwTwoFactorStepWrapper = tw.div`
  w-400px
  absolute
  top-1/2
  left-1/2
  transform
  -translate-x-1/2
  -translate-y-1/2
  text-left
`

export const TwTwoFactorStepInner = tw.div`
  flex
  flex-col
  gap-20
`

export const TwDialogDescription = tw.div`
  text-primary
  text-left  
`

export const TwAttentionDescription = tw.div`
  text-action-attention-default
`

export const TwError = tw.div`
  text-action-attention-default
  text-left
`
